import { filters } from '@/configs/translates.config';

export default {
	'add-new-filter': `Add new ${filters.en.singular}`,
	filter: filters.en.singular,
	'the-filter': `the ${filters.en.singular}?`
}